<template>
<section>
    <div class="wrap">

        <ul class="car_list">

            <li v-for="(modelId) in trimItemsGroupByModelTop" :key="`select-model-${modelId}`">

                <a :style="`background-image:url(${viewModelAttUrl(trimItemsGroupByModel[modelId][0].modelUrl)});`"
                    @click="slide(modelId)"
                >
                    <span><!--{{trimItemsGroupByModel[modelId][0].brandName}}-->{{trimItemsGroupByModel[modelId][0].modelName}}<i class="far fa-chevron-right"></i></span>
                </a>

                <ul :class="['box', { 'show' : (showItem == modelId) }]">
                    <li v-for="(trim) in trimItemsGroupByModel[modelId]" :key="`select-model-${modelId}-trim-${trim.id}`">
                        <a @click="routerPush(trim)">- {{trim.name}}</a>
                    </li>
                </ul>

            </li>

            <swiper
                v-if="bannerItems.length > 0"
                class="swiper vehicle-banner"
                :options="swiperOption"
            >

                <swiper-slide class="item" v-for="banner in bannerItems" :key="banner.id">
                    <a @click="openWindow(banner.content)">
                        <div class="vehicle-banner-img">
                            <img :src="banner.bannerUrl">
                        </div>
                    </a>
                </swiper-slide>

                <div class="swiper-pagination" slot="pagination"></div>

            </swiper>

            <li v-for="(modelId) in trimItemsGroupByModelFooter" :key="`select-model-${modelId}`">
                <a :style="`background-image:url(${viewModelAttUrl(trimItemsGroupByModel[modelId][0].modelUrl)});`"
                    @click="slide(modelId)"
                >
                    <span><!--{{trimItemsGroupByModel[modelId][0].brandName}}-->{{trimItemsGroupByModel[modelId][0].modelName}}<i class="far fa-chevron-right"></i></span>
                </a>
                <ul :class="['box', { 'show' : (showItem == modelId) }]">
                    <li v-for="(trim) in trimItemsGroupByModel[modelId]" :key="`select-model-${modelId}-trim-${trim.id}`">
                        <a @click="routerPush(trim)">{{trim.name}}</a>
                    </li>
                </ul>
            </li>

            <!-- <li v-for="(trims,modelId) in trimItemsGroupByModel" :key="`select-model-${modelId}`">
                <a :style="`background-image:url(${viewModelAttUrl(trims[0].modelUrl)});`"
                    @click="slide(modelId)"
                >
                    <span>{{trims[0].brandName}} {{trims[0].modelName}}</span>
                </a>
                <ul :class="['box', { 'show' : (showItem == modelId) }]">
                    <li v-for="(trim) in trims" :key="`select-model-${modelId}-trim-${trim.id}`">
                        <a @click="routerPush(trim)">{{trim.name}}</a>
                    </li>
                </ul>
            </li> -->

            <!--<li>
                <a :style="`background-image:url(${$store.state.dir}images/group_2355.png);`" class="advertising">
                    <dl>
                        <dt>BMW KOREA</dt>
                        <dd>BMW eDrive 프로모션</dd>
                    </dl>
                </a>
            </li>-->
        </ul>

    </div>
</section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { DateFormatMixin } from '../../mixins/DateFormatMixin';
import { BodyBgColorMixin } from '../../mixins/BodyBgColorMixin';

export default {
    name:'VehicleList',
    mixins:[
        BodyBgColorMixin,
        DateFormatMixin
    ],

    data() {
        return {
            filters: {...this.$store.state.banner.filters},

            swiperOption: {
                // loop: true, // loop 여부
                autoHeight: true, //enable auto height
                spaceBetween: 5, //거리
                autoplay: { 
                    delay: 4000, 
                },
                pagination: {
                    el: '.swiper-pagination'
                }
            },

            bannerItems: [],
            showItem: 0,
        }
    },

    created() {
        
        this.getItems();
        
    },

    computed: {
        ...mapState({
            brandItems: state => state.brand.items,
            trimItems: state => state.trim.items,

            bookingWrite: state => state.booking.itemWrite,

            resource: state => state.resource,
            BANNER_DTYPE_ADVERTISEMENT: state => state.codeDictionary.items.BANNER_DTYPE.ADVERTISEMENT.id,
        }),

        ...mapGetters([
            'viewModelAttUrl'
        ]),

        bookingId(){ return Number(this.$route.params.bookingId);},
        brandId(){return Number(this.$route.params.brandId);},

        brandItem() {
            return this.brandItems.find( brandItem => brandItem.id == this.brandId );
        },

        trimItemsGroupByModel()
        {
            return this.trimItems.reduce((acc, curr) => {
                if(!acc[curr.modelId]) acc[curr.modelId] = []; 
                acc[curr.modelId].push(curr);
                return acc;
            },{});
        },

        trimItemsGroupByModelTop() {
            let Objectkeys = Object.keys(this.trimItemsGroupByModel);
            return Objectkeys.slice(0,2);
            
        },

        trimItemsGroupByModelFooter() {
            let Objectkeys = Object.keys(this.trimItemsGroupByModel);
            return Objectkeys.slice(2,Objectkeys.length);
        },

        routerBookingChk() 
        {
            return (['BookingSelectVehicle', 'BookingChangeSelectVehicle'].includes(this.$route.name));
        },

        routerBookingPath(){
            let path = '/booking/inputBasic';
            return (this.bookingId) ? `${path}/${this.bookingId}`: path;
        }

    },
    methods: {
        async getItems() {
            await this.$store.dispatch('GET_TRIM_LIST', { brandId: this.brandId })
            .then( () => {
                this.setHeaderTitle();
                this.$store.dispatch('GET_BANNER_LIST', {   
                    type: this.BANNER_DTYPE_ADVERTISEMENT,
                    showDt: this.dayjsFormat(this.getToday() , 'YYYY-MM-DD'),
                    brandIdWithNull: this.brandId,
                })
                .then((data)=>{
                    this.bannerItems = data.content;
                });
            });

            this.$store.commit('SHOW_ONLOAD');
        },
        setHeaderTitle() 
        {
            let findItem = this.brandItems.find((brand) => { return brand.id == this.brandId });
            this.$store.state.headerTitle = (findItem) ? findItem.name: '';
        },

        routerPush(trim) 
        {
            let path = `/vehicleInfo/${trim.id}`;

            if(this.routerBookingChk) 
            {
                this.bookingWrite.brandId = this.brandItem.id;
                this.bookingWrite.brandName = this.brandItem.name;
                this.bookingWrite.brandUrl = this.brandItem.url;

                this.bookingWrite.modelId = trim.modelId;
                this.bookingWrite.modelName = trim.modelName;
                this.bookingWrite.modelUrl = trim.modelUrl;

                this.bookingWrite.trimId = trim.id;
                this.bookingWrite.trimName = trim.name;

                path = this.routerBookingPath;
            }

            this.$router.push(path)   
        },

        slide(modelId) {
            if( this.showItem == modelId ) this.showItem = 0;
            else this.showItem = modelId;
        },
    },
}
</script>

<style scoped>
.box {
    display: block;
    height: 0px;
    
}
.show {
    height: fit-content;
}
</style>